export const getFAQSchema = (pageBlocks) => {
  if (!pageBlocks) return null;

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [],
  };

  const isAlreadyInSchema = (item, faqSchema) =>
    faqSchema.mainEntity.find(
      (el) =>
        el.name === item.question.text &&
        el.acceptedAnswer.text === item.answer.text
    );

  const faqBlocks = pageBlocks.filter(
    (block) => block.slice_type === 'block_faqs'
  );

  // Build a unique faq schema per block as controlled by prismic
  for (const block of faqBlocks) {
    const faqSchemaItems = block.items.filter((item) => item['use_faq_schema']);

    for (const item of faqSchemaItems) {
      if (!isAlreadyInSchema(item, faqSchema)) {
        faqSchema.mainEntity.push({
          '@type': 'Question',
          name: item.question.text,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer.text,
          },
        });
      }
    }
  }

  if (faqSchema?.mainEntity?.length < 1) {
    return null;
  } else {
    return JSON.stringify(faqSchema, null, 2);
  }
};
